import { render } from "./collectList.vue?vue&type=template&id=110b73ab&scoped=true"
import script from "./collectList.vue?vue&type=script&lang=js"
export * from "./collectList.vue?vue&type=script&lang=js"

import "./collectList.vue?vue&type=style&index=0&id=110b73ab&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110b73ab"]])

export default __exports__